import { render, staticRenderFns } from "./PlacementTest.vue?vue&type=template&id=0b2346a0&scoped=true"
import script from "./PlacementTest.vue?vue&type=script&lang=js"
export * from "./PlacementTest.vue?vue&type=script&lang=js"
import style0 from "./PlacementTest.vue?vue&type=style&index=0&id=0b2346a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2346a0",
  null
  
)

export default component.exports